import { render, staticRenderFns } from "./PlantConfigurationInductionsPage.vue?vue&type=template&id=50d43d97&"
import script from "./PlantConfigurationInductionsPage.vue?vue&type=script&lang=js&"
export * from "./PlantConfigurationInductionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports